import { useRefreshTokenMutation } from '../api/auth.api'
import { isCookieAuthenticationEnabled } from '../utils/isCookieAuthenticationEnabled'

import { useAppSelector } from '@v2/store/hooks'

export const useTokenRefresh = () => {
  const currentRefreshToken = useAppSelector((state) => state.auth.refreshToken)
  const organizationId = useAppSelector((state) => state.auth.organizationId)
  const membershipId = useAppSelector((state) => state.auth.membershipId)
  const [refreshTokenMutation, { isLoading, isError, error }] =
    useRefreshTokenMutation()

  const mutateAsync = async () => {
    if (!isCookieAuthenticationEnabled && !currentRefreshToken) {
      throw new Error('No refresh token available')
    }

    const result = await refreshTokenMutation({
      ...(!isCookieAuthenticationEnabled && {
        refreshToken: currentRefreshToken,
        refresh_token: currentRefreshToken,
      }),
      ...(organizationId && { organizationId }),
      ...(membershipId && { membershipId }),
    }).unwrap()

    return result
  }

  return {
    mutateAsync,
    isLoading,
    isError,
    error,
  }
}

export default useTokenRefresh
